document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.homepage-featured-box-btn[href^="#"]').forEach((link) => {
    link.addEventListener('click', (event) => {
      const targetId = link.getAttribute('href');
      const target = document.querySelector(targetId);

      if (!target) return;

      event.preventDefault();

      const header = document.querySelector('.header-section--wrapper');
      const headerHeight = header ? header.offsetHeight : 0;

      const targetPosition =
        target.getBoundingClientRect().top +
        window.pageYOffset -
        headerHeight;

      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });

      // Optional: update URL hash without jumping
      history.pushState(null, '', targetId);
    });
  });
});